import React, { CSSProperties } from 'react';
import { Config } from 'react-player';
import { PageData } from '../../../../../interfaces/interfaces';
import { StageComponentInterface } from '../../../../../interfaces/pagebuilder';
import { useSelector } from '../../../../../reduxToolkit/typedRedux';
import { createDisplayLink } from '../../../../../services/helper';
import VyReactPlayer from '../../../../common/VyReactPlayer';
import VystemStream from './VystemStream';
import VystemStudio from './VystemStudio';

interface stageSyncedVideoProps extends React.HTMLAttributes<HTMLDivElement> {
  stageSettings: PageData['stageSettings'];
  iFrameStyle?: CSSProperties;
  // to remove the second type once the default components are fully deprecated
  uiComponent?: StageComponentInterface;
  playerStyle?: CSSProperties;
  onCustomFullScreen?: (time?: number, isPlaying?: boolean) => void;
  isFullScreen?: boolean;
  openCustomFullScreen?: boolean;
  currentTime?: number;
  isPlaying?: boolean;
  showControls?: boolean;
}

// lib is broken
const config: Config = {
  vimeo: {
    playerOptions: { maxwidth: '985', width: '985' },
  },
  file: {
    attributes: {
      disablepictureinpicture: 'true',
    },
  },
};

const GeneralStageVideo = ({
  stageSettings,
  iFrameStyle,
  playerStyle,
  uiComponent,
  onCustomFullScreen,
  isFullScreen = false,
  openCustomFullScreen,
  isPlaying,
  ...props
}: stageSyncedVideoProps) => {
  const isTabUsedElsewhere = useSelector(({ common }) => common.isTabUsedElsewhere);

  const renderVideo = () => {
    let videoElement = <></>;
    switch (stageSettings.streamType) {
      case 'vystemvideo':
        videoElement = (
          <iframe onClick={props?.onClick} src={stageSettings.streamUrl} width="100%" height="100%" frameBorder={0} scrolling="no" allowFullScreen />
        );
        break;
      case 'Vystemstream':
        videoElement = (
          <VystemStream
            playerStyle={playerStyle}
            stageSettings={stageSettings}
            iFrameStyle={iFrameStyle}
            uiComponent={uiComponent}
            onCustomFullScreen={onCustomFullScreen}
            onClickResize={props?.onClick}
            isFullScreen={isFullScreen}
            openCustomFullScreen={openCustomFullScreen}
            currentTime={props.currentTime}
            isPlaying={isPlaying}
          />
        );
        break;
      case 'iFrame':
        videoElement = (
          <div className="transition-transform	" style={playerStyle ?? { position: 'relative', overflow: 'hidden', width: '100%', paddingTop: '54.25%' }}>
            <div style={iFrameStyle} dangerouslySetInnerHTML={{ __html: stageSettings.iFrame ?? '' }}></div>
          </div>
        );
        break;
      case 'vystemStudio':
        videoElement = (
          <VystemStudio
            playerStyle={playerStyle}
            stageSettings={stageSettings}
            uiComponent={uiComponent}
            onClickResize={props?.onClick}
            currentTime={props.currentTime}
            isPlaying={isPlaying}
          />
        );
        break;
      default:
        videoElement = (
          <VyReactPlayer
            props={{
              style: playerStyle ?? { backgroundColor: 'black', width: '100%', maxWidth: '100% !important' },
              config,
              width: '100%',
              height: '100%',
              controls: props.showControls ?? true,
              loop: uiComponent?.stageSettings?.isLoopVideo,
              playing: isPlaying ?? uiComponent?.stageSettings?.autoplay,
              muted: uiComponent?.stageSettings?.isLoopVideo || uiComponent?.stageSettings?.autoplay || isTabUsedElsewhere,
              light: stageSettings?.thumbnail && !uiComponent?.stageSettings?.autoplay ? createDisplayLink(stageSettings?.thumbnail) : undefined,
              url: stageSettings.streamUrl,
            }}
            uiComponent={uiComponent}
            wrapperProps={props}
            playerStyle={playerStyle}
            onCustomFullScreen={onCustomFullScreen}
            isFullScreen={isFullScreen}
            openCustomFullScreen={openCustomFullScreen}
            currentTime={props.currentTime}
          />
        );
        break;
    }
    return videoElement;
  };
  return <div {...props}>{renderVideo()}</div>;
};

export default GeneralStageVideo;
